import { render, staticRenderFns } from "./Sppd.vue?vue&type=template&id=9fc5d508&"
import script from "./Sppd.vue?vue&type=script&lang=js&"
export * from "./Sppd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports